import { useParams } from "react-router-dom";
import SettingSectionPage from "./SettingSectionPage";
import CityZonePage from "./CityZonePage";
import TemplatesPage from "./TemplatesPage";
import { getSectionConfig } from "./sectionConfigs";

/**
 * SectionRouter — Routes to the correct settings sub-page.
 *
 * Most sections use the generic SettingSectionPage.
 * City & Zone / Templates use custom pages.
 */
export default function SectionRouter() {
  const { section } = useParams();
  const config = getSectionConfig(section);

  if (!config) {
    return <div style={{ padding: 24 }}>Section not found</div>;
  }

  if (config.disabled) {
    return <div style={{ padding: 24 }}>This section is coming soon.</div>;
  }

  if (config.isCustomPage) {
    if (section === "city-zones") return <CityZonePage />;
    if (section === "templates") return <TemplatesPage />;
  }

  return <SettingSectionPage />;
}
